import React, { useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { APP_API_URL } from '../../utils';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Add({ open, onClose, refreshData }) {
  const user = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    nom: '',
    type_categorie: null,
    private: true,
    user_id: user?.id,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const resetForm = () => {
    setFormData({ nom: '', type_categorie: null, private: true, user_id: user?.id });
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${APP_API_URL}/categories`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: response.data.message || 'La catégorie a été créée avec succès.',
        timer: 2000,
        showConfirmButton: false,
      });

      resetForm();
      onClose();
      refreshData();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Veuillez vérifier les champs du formulaire.',
        });
      } else {
        console.error("Erreur lors de l'envoi du formulaire", error);
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title="Ajouter une catégorie"
      onClose={handleClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={handleClose} disabled={isLoading}>
            Annuler
          </button>
          <button
            type="submit"
            form="add-category-form"
            className="duo-btn duo-btn--primary"
            disabled={isLoading}
          >
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id="add-category-form" onSubmit={handleSubmit}>
        <div className="duo-form-group">
          <label htmlFor="add-category-nom" className="duo-form-label">
            Nom de la catégorie *
          </label>
          <input
            type="text"
            className="duo-input"
            id="add-category-nom"
            name="nom"
            value={formData.nom}
            onChange={handleChange}
          />
          {errors.nom && <p className="text-danger small mt-1 mb-0">{errors.nom[0]}</p>}
        </div>
        <div className="duo-form-group mb-0">
          <label className="duo-form-label d-flex align-items-start gap-2">
            <input
              type="checkbox"
              className="form-check-input mt-1"
              id="add-category-private"
              name="private"
              checked={formData.private}
              onChange={handleChange}
            />
            <span>
              Catégorie active
              <span className="d-block fw-normal" style={{ fontSize: '0.78rem', color: '#777' }}>
                Décochez pour rendre la catégorie inactive.
              </span>
            </span>
          </label>
          {errors.private && <p className="text-danger small mt-1 mb-0">{errors.private[0]}</p>}
        </div>
      </form>
    </DuoModal>
  );
}
